import React, { useEffect, useState } from "react";
import axios from "axios";
import { EditFolderTypes, FolderList } from "./modal";
import FileDownload from "js-file-download";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// const getFilename = function (str: any) {
//     const MAX_FILENAME_LENGTH = 20;

//     if (str) {
//         let filename = str.replace(/^.*[\\\/]/, "");
//         if (filename.length > MAX_FILENAME_LENGTH) {
//             const halfLength = Math.floor((MAX_FILENAME_LENGTH - 3) / 2);
//             const firstHalf = filename.substr(0, halfLength);
//             const secondHalf = filename.substr(-halfLength);
//             filename = `${firstHalf}...${secondHalf}`;
//         }
//         return filename;
//     } else {
//         return "";
//     }
// };

export const fetchFolderList = async (companyProfileID: number) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Folder/CompanyId/${companyProfileID}/Details`
    );

    // console.log("fetchFolderList res", res);
    return res.data.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

export const createFolder = async (payload: any) => {
  try {
    // console.log("createFolder payload", payload);

    const res = await axios.post(`${API_BASE_URL}/api/Folder/Details`, payload);
    // console.log("createFolder res", res);

    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};
export const EditFolder = async (payload: EditFolderTypes) => {
  try {

    const res = await axios.put(`${API_BASE_URL}/api/Folder/Details`, payload);
    // console.log("EditFolder res", res);

    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

export const renameFolder = async (payload: any) => {
  try {
    const res = await axios.put(`${API_BASE_URL}/api/Policy`, payload);
    // console.log("editPolicy res", res.data);

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const deleteFolder = async (folderDetails: any) => {
  try {
    // console.log("deleteFolder", folderDetails);
    let payload = {
      folderName: folderDetails.folderName,
    };

    const res = await axios.delete(
      `${API_BASE_URL}/api/Folder/Details/${folderDetails.folderId}`,
      {
        data: payload,
      }
    );
    // console.log("deleteFolder res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Files API
export const fetchFileList = async (props: FolderList | null) => {
  // console.log("fetchFileList", props);

  try {
    const res = await axios.get(
      // `${API_BASE_URL}/api/FileRepository/AllFolderDetails?pageNumber=1&pageSize=10`
      `${API_BASE_URL}/api/FileRepository/Folder-ID/${props?.folderId}/Files/Information`
    );

    // console.log("fetchFileList res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const uploadFiles = async (
  files: File[] | null,
  selectedFolder?: FolderList | null,
  userId?: number
) => {
  try {
    if (!files || files.length === 0) {
      throw new Error("No files selected for upload");
    }


    const formData = new FormData();

    // Append each file individually under the same key
    files.forEach((file, index) => {
      formData.append("files", file);
    });

    const res = await axios.post(
      `${API_BASE_URL}/api/FileRepository/Upload/Files?folderId=${selectedFolder?.folderId}&folderName=${selectedFolder?.folderName}&createdBy=${userId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};


export const deleteFiles = async (payload: any) => {
  try {
    // console.log("deleteFiles", payload);

    // const res = await axios.delete(`${API_BASE_URL}/api/FileRepository/deleteFiles`, {
    //     data: payload
    // });

    const res = await axios.put(
      `${API_BASE_URL}/api/FileRepository/delete/Files`,
      payload
    );
    // console.log("deleteFiles res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

export const downloadFiles = async (payload: any) => {
  try {
    // console.log("downloadFiles", payload);

    // const fileName = getFilename(payload.filePath);
    // console.log("downloadFiles", "fileName", payload.fileName);

    axios({
      url: `${API_BASE_URL}/api/FileRepository/${payload.folderId}/Download/File/${payload.fileId}`,
      method: "GET",
      responseType: "blob", // Important
    }).then((response) => {
      // console.log("downloadFiles response", payload);

      FileDownload(response.data, payload.fileName);
    });
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

export const fetchUserDetails = async () => {
  // console.log("fetchUserDetails", props);

  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Users/ApplicationUsers/Details`
    );

    // console.log("fetchUserDetails res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};
